<template>
  <div class="show-video__container">
    <div class="col-left">
      <div class="text-white">
        Ver tutorial <img
          src="../../assets/continue-icon.svg"
          alt=""
        >
      </div>
    </div>
    <div class="col-right">
      <div class="hola">
        ¡Hola!
      </div>
      <div class="do-p">
        Bienvenido a la plataforma de
      </div>
      <div>
        <img
          src="../../assets/img/egresa_logo.png"
          class="egresado"
          alt
        >
      </div>
      <video-player
        ref="videoPlayer"
        class="video-player-box"
        :options="playerOptions"
        @ended="nextStep"
        @timeupdate="onPlayerTimeupdate($event)"
      />
      <div
        class="pt-3 mx-0 d-flex"
        :style="{ width: '100%' }"
      >
        <span
          v-if="!canContinue"
        >Podrás saltar el video en {{ timeLeft }}
          {{ (timeLeft === 1)? 'segundo': 'segundos' }}</span>
        <base-button
          v-else
          inverse
          class="mx-auto"
          :style-prop="{ margin: 0 }"
          @click="nextStep"
        >
          Saltar video
        </base-button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable import/no-extraneous-dependencies */
import 'video.js/dist/video-js.css';
import { videoPlayer } from 'vue-video-player';
import { mapActions, mapMutations } from 'vuex';

export default {
    name: 'ShowVideo',
    components: {
        videoPlayer,
    },
    data() {
        return {
            canContinue: false,
            currentTime: 0,
            playerOptions: {
                fluid: true,
                controls: true,
                autoplay: true,
                sources: [
                    {
                        type: 'video/mp4',
                        src: 'vid/video_inicial.mp4',
                    },
                ],
            },
        };
    },
    computed: {
        timeLeft() {
            return (11 - this.currentTime).toFixed();
        },
    },
    mounted() {
        this.$nextTick(function () {
            this.checkedVideo();
        });
    },
    methods: {
        ...mapActions('loginDialog', ['setNextDialog']),
        ...mapMutations('authentication', ['checkedVideo', 'seenVideo']),
        nextStep() {
            this.seenVideo();
            this.setNextDialog();
        },
        onPlayerTimeupdate(player) {
            this.currentTime = player.currentTime();
            if (player.currentTime() >= 10) {
                this.canContinue = true;
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.show-video__container{
  display: block;
  @media screen and (min-width: 600px) {
    display: flex;
    min-width: 100%;
    min-height: 100vh;
  }
}
.hola {
  font-family: "Roboto", sans-serif;
  text-transform: uppercase;
  font-size: 61px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.36;
  letter-spacing: normal;
  text-align: left;
  color: #0a2139;
}
.egresado {
  width: 249px;
  height: 72px;
  margin-bottom: 30px;
}
.col-left{
  display: none;
  @media screen and (min-width: 600px) {
    min-width: 260px;
    background: #0A2139;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px 10px;
    text-transform: uppercase;
  }
  @media screen and (min-width: 1025px) {
    min-width: 526px;
    padding: 20px;
  }
}
.col-right{
  padding: 1rem;
  @media screen and (min-width: 600px) {
    flex: 1;
  }
}
</style>
